import httpClient from "../../../shared/api/httpClient";

export const plantoesApi = {
  // filtros: { status, vinculoId, ano, mes, anoPagamento, mesPagamento, dataInicio,
  // dataFim } — todos opcionais. ano/mes é o mês de serviço (Calendário);
  // anoPagamento/mesPagamento é o mês em que o pagamento cai (Recebíveis, issue #18).
  // dataInicio/dataFim (período personalizado, "yyyy-MM-dd") têm prioridade sobre os
  // meses no backend — o chamador nunca deveria enviar os dois ao mesmo tempo.
  list: (filtros = {}) => {
    const params = new URLSearchParams();
    if (filtros.status) params.set("status", filtros.status);
    if (filtros.vinculoId) params.set("vinculo_id", filtros.vinculoId);
    if (filtros.dataInicio && filtros.dataFim) {
      params.set("data_inicio", filtros.dataInicio);
      params.set("data_fim", filtros.dataFim);
    } else {
      if (filtros.ano) params.set("ano", filtros.ano);
      if (filtros.mes) params.set("mes", filtros.mes);
      if (filtros.anoPagamento) params.set("ano_pagamento", filtros.anoPagamento);
      if (filtros.mesPagamento) params.set("mes_pagamento", filtros.mesPagamento);
    }
    const qs = params.toString();
    return httpClient.get(`/api/v1/plantoes${qs ? `?${qs}` : ""}`).then((r) => r.data.dados);
  },

  // horaInicio ("HH:MM") é opcional: vazio vira null, plantão sem hora definida.
  create: ({ vinculoId, data, horas, valor, horaInicio = "", observacao = "", importante = false }) =>
    httpClient
      .post("/api/v1/plantoes", {
        vinculo_id: vinculoId,
        data,
        horas,
        valor,
        hora_inicio: horaInicio || null,
        observacao,
        importante,
      })
      .then((r) => r.data.dados),

  // Mesmo plantão em várias datas. Datas em que o vínculo já tem plantão são puladas pelo
  // backend: a resposta traz { criados: [...], pulados: ["yyyy-MM-dd", ...] }.
  createBatch: ({ vinculoId, datas, horas, valor, horaInicio = "", observacao = "", importante = false }) =>
    httpClient
      .post("/api/v1/plantoes/lote", {
        vinculo_id: vinculoId,
        datas,
        horas,
        valor,
        hora_inicio: horaInicio || null,
        observacao,
        importante,
      })
      .then((r) => r.data.dados),

  // Aviso de conflito de horário (não bloqueia o cadastro): devolve os plantões que batem
  // com o proposto em qualquer uma das datas. `ignorarId` tira o próprio plantão na edição.
  checkConflicts: ({ datas, horaInicio, horas, ignorarId }) => {
    const params = new URLSearchParams();
    datas.forEach((data) => params.append("data", data));
    if (horaInicio) params.set("hora_inicio", horaInicio);
    if (horas) params.set("horas", horas);
    if (ignorarId) params.set("ignorar_id", ignorarId);
    return httpClient.get(`/api/v1/plantoes/conflitos?${params.toString()}`).then((r) => r.data.dados.conflitos ?? []);
  },

  updateStatus: ({ id, acao }) =>
    httpClient.patch(`/api/v1/plantoes/${id}/status`, { acao }).then((r) => r.data.dados),

  // Mesma ação em vários plantões de uma vez. O backend é tudo-ou-nada: se algum id não
  // aceita a transição, nada é gravado — por isso o chamador só envia os elegíveis.
  updateStatusBulk: ({ ids, acao }) =>
    httpClient.patch("/api/v1/plantoes/status", { ids, acao }).then((r) => r.data.dados),

  // Atualização parcial (data/horas/valor e detalhes de agenda) — usada tanto pela edição
  // completa (Recebíveis) quanto pelo reagendamento (Calendário, que só envia `data`).
  // Campos ausentes não são enviados, para o backend não sobrescrever com um valor vazio;
  // horaInicio "" é enviado de propósito: remove a hora do plantão.
  edit: ({ id, data, horas, valor, horaInicio, observacao, importante }) => {
    const payload = {};
    if (data !== undefined) payload.data = data;
    if (horas !== undefined) payload.horas = horas;
    if (valor !== undefined) payload.valor = valor;
    if (horaInicio !== undefined) payload.hora_inicio = horaInicio;
    if (observacao !== undefined) payload.observacao = observacao;
    if (importante !== undefined) payload.importante = importante;
    return httpClient.patch(`/api/v1/plantoes/${id}`, payload).then((r) => r.data.dados);
  },

  cancel: ({ id, motivo }) =>
    httpClient.patch(`/api/v1/plantoes/${id}/cancelar`, { motivo }).then((r) => r.data.dados),

  getReagendamentos: (id) =>
    httpClient.get(`/api/v1/plantoes/${id}/reagendamentos`).then((r) => r.data.dados.reagendamentos),
};
